<template>
	<v-card class="mx-auto" elevation="0">
		<v-card-title class="card-header fixed-card-title2">
			{{ $t('edit-location-mapping') }}
			<v-spacer></v-spacer>
			<v-icon @click="closeDrawer" class="white-icon mr-3">mdi-close</v-icon>
		</v-card-title>
		<v-card-text>
			<v-row class="mt-2">
				<v-col class="d-flex pa-1" cols="12" sm="12">
					<v-select
						class="py-1"
						hide-details
						dense
						v-model="selectedLocationToEdit.mappedMedicalInstitutionId"
						:items="allMedicalInstitutions"
						item-value="id"
						item-text="institutionName"
						:label="$t('organizations')"
						outlined
						disabled>
					</v-select>
				</v-col>

				<v-col class="d-flex pa-1" cols="12" sm="12">
					<v-select
						:items="notMappedLocationsFiltered"
						item-text="hospital.hospitalName"
						item-value="mappedHospitalId"
						outlined
						hide-details
						dense
						:label="`${$t('location')}`"
						v-model="selectedLocationToEdit.mappedHospitalId"
						disabled></v-select>
				</v-col>
				<v-col>
					<v-divider />
				</v-col>

				<v-col class="d-flex pa-1" cols="12" sm="12">
					<v-text-field
						outlined
						dense
						hide-details="auto"
						v-model="selectedLocationToEdit.ecpLocationName"
						:label="`${$t('ecp-location-name')}`"
						required>
					</v-text-field>
				</v-col>

				<v-col class="d-flex pa-1" cols="12" sm="12">
					<v-text-field
						outlined
						dense
						hide-details="auto"
						v-model="selectedLocationToEdit.ecpLocationId"
						:label="`${$t('location')} GUID`"
						required>
					</v-text-field>
				</v-col>

				<v-col>
					<v-divider />
				</v-col>

				<v-col class="d-flex pa-1" cols="12" sm="12">
					<v-text-field
						outlined
						dense
						hide-details="auto"
						v-model="selectedLocationToEdit.apiKey"
						:label="`${$t('api-key')}`"
						required>
					</v-text-field>
				</v-col>

				<v-col class="d-flex pa-1" cols="12" sm="12">
					<v-text-field
						outlined
						dense
						hide-details="auto"
						v-model="selectedLocationToEdit.clientId"
						:label="`${$t('client-id')}`"
						required>
					</v-text-field>
				</v-col>

				<v-col class="d-flex pa-1" cols="12" sm="12">
					<v-textarea
						rows="2"
						no-resize
						outlined
						dense
						hide-details="auto"
						v-model="selectedLocationToEdit.clientSecret"
						:label="`${$t('client-secret')}`"
						required>
					</v-textarea>
				</v-col>

				<v-col>
					<v-divider />
				</v-col>

				<v-col class="d-flex pa-1" cols="12" sm="12">
					<v-checkbox
						outlined
						dense
						hide-details="auto"
						v-model="selectedLocationToEdit.finalizeMeasurementAutomatically"
						:label="`${$t('finalize-measurement-automatically')}`" />
				</v-col>

				<v-col class="d-flex pa-1" cols="12" sm="12">
					<v-checkbox
						outlined
						dense
						hide-details="auto"
						v-model="selectedLocationToEdit.residentCreationIsAutomatic"
						:label="`${$t('resident-creation-is-automatic')}`" />
				</v-col>

				<v-col class="d-flex pa-1" cols="12" sm="12">
					<v-checkbox
						outlined
						dense
						hide-details="auto"
						v-model="selectedLocationToEdit.userCreationIsAutomatic"
						:label="`${$t('resident-creation-is-automatic')}`" />
				</v-col>
			</v-row>
		</v-card-text>
		<v-card-actions class="fixed-card-actions">
			<v-row dense class="mx-0 px-0 mr-2">
				<v-col cols="6">
					<v-btn elevation="0" @click="closeDrawer" class="cancel-button-style capitalize-text">
						{{ $t('cancel') }}
					</v-btn>
				</v-col>
				<v-col cols="6">
					<v-btn
						:disabled="isSaveLocationMappingButtonDisabled()"
						@click="editLocationMapping"
						class="save-button-style">
						{{ $t('save') }}
					</v-btn>
				</v-col>
			</v-row>
		</v-card-actions>
	</v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import MappingRepository from '../../data/repositories/v1/MappingRepository';

export default {
	name: 'LocationMappingEdit',
	data: () => ({
		componentKey: 0,
		menu: false,
		defaultTimeZone: 'America/Chicago',
		selectedMedicalInstitution: null,
		ecpCompanyGuid: '',
		ecpCompanyName: '',
		selectedLocationToEdit: {
			ecpLocationId: '',
			mappedHospitalId: 0,
			mappedMedicalInstitutionId: 0,
			ecpLocationName: '',
			finalizeMeasurementAutomatically: false,
			residentCreationIsAutomatic: false,
			userCreationIsAutomatic: false,
			apiKey: '',
			clientId: '',
			clientSecret: '',
		},
		notMappedLocationsFiltered: [],
		notMappedLocations: [],
	}),
	computed: {
		...mapState({
			allMedicalInstitutions: (state) => state.medicalInstitutions.medicalInstitutions,
			hospitals: (state) => state.hospitals.hospitals,
			selectedLocation: (state) => state.mapping.selectedLocation,
			updateDrawer: (state) => state.updateDrawer,
		}),
		...mapGetters({
			getTimeZone: 'verifiers/getTimeZone',
		}),
	},
	async mounted () {
		this.selectedLocationToEdit = this.selectedLocation;
		await this.getEcpNotMappedLocation();
	},
	methods: {
		async getEcpNotMappedLocation () {
			MappingRepository.getMappedEcpLocation().then((res) => {
				this.notMappedLocations = res;
				this.notMappedLocationsFiltered = this.notMappedLocations.filter(
					(n) => n.hospital.medicalInstitutionId === this.selectedLocationToEdit.mappedMedicalInstitutionId,
				);
			});
		},
		isSaveLocationMappingButtonDisabled () {
			return (
				this.selectedLocationToEdit.ecpLocationId?.length === 0 ||
				this.selectedLocationToEdit.mappedHospitalId === 0 ||
				this.selectedLocationToEdit.mappedMedicalInstitutionId === 0 ||
				this.selectedLocationToEdit.ecpLocationName?.length === 0 ||
				this.selectedLocationToEdit.apiKey?.length === 0 ||
				this.selectedLocationToEdit.clientId?.length === 0 ||
				this.selectedLocationToEdit.clientSecret?.length === 0
			);
		},
		resetComponent () {
			this.selectedLocationToEdit = {
				id: -1,
				ecpCompanyId: '',
				ecpCompanyName: '',
				medicalInstitution: null,
			};
		},
		async editLocationMapping () {
			MappingRepository.updateEcpMapForLocation({
				...this.selectedLocationToEdit,
				medicalInstitutionId: this.selectedLocationToEdit.medicalInstitution.id,
			}).then((res) => {
				this.closeDrawer();
			});
		},
		closeDrawer () {
			this.resetComponent();
			this.$store.commit('SET_UPDATE_DETAILS_DRAWER', false);
		},
		medicalInstitutionSelected () {
			return this.selectedLocationToEdit.medicalInstitution;
		},
	},

	watch: {
		'selectedLocationToEdit.mappedMedicalInstitutionId' (val) {
			if (this.notMappedLocations.length > 0) {
				this.notMappedLocationsFiltered = this.notMappedLocations.filter((n) => n.medicalInstitutionId === val);
			}
		},
		async updateDrawer (val) {
			if (val) {
				this.selectedLocationToEdit = this.selectedLocation;
				await this.getEcpNotMappedLocation();
			}
		},
	},
};
</script>
<style scoped>
.map-container {
	margin-top: 20px;
	/* Adjust this margin as needed */
}
</style>
